/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { TotalCount } from '../model';
/**
 * LawsApi - axios parameter creator
 * @export
 */
export const LawsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 法令の全数カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLawsCount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/laws/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LawsApi - functional programming interface
 * @export
 */
export const LawsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LawsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 法令の全数カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLawsCount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLawsCount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LawsApi - factory interface
 * @export
 */
export const LawsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LawsApiFp(configuration)
    return {
        /**
         * 
         * @summary 法令の全数カウント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLawsCount(options?: any): AxiosPromise<TotalCount> {
            return localVarFp.getLawsCount(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LawsApi - interface
 * @export
 * @interface LawsApi
 */
export interface LawsApiInterface {
    /**
     * 
     * @summary 法令の全数カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LawsApiInterface
     */
    getLawsCount(options?: AxiosRequestConfig): AxiosPromise<TotalCount>;

}

/**
 * LawsApi - object-oriented interface
 * @export
 * @class LawsApi
 * @extends {BaseAPI}
 */
export class LawsApi extends BaseAPI implements LawsApiInterface {
    /**
     * 
     * @summary 法令の全数カウント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LawsApi
     */
    public getLawsCount(options?: AxiosRequestConfig) {
        return LawsApiFp(this.configuration).getLawsCount(options).then((request) => request(this.axios, this.basePath));
    }
}
